import * as React from 'react'
import { Route, Switch } from 'react-router-dom'
import { History } from 'history'
import { MessageKind } from 'uiComponents/messages'
import { FullWidthContainerBody } from 'uiComponents/settingsContainer'
import WithRoutePermission from 'routes/guards/withRoutePermission'
import InventoryRuleForm from 'inventory/ruleEditForm'
import { CapacityPage } from './pages/capacityPage/capacityPage'
import { CapacityListPage } from './pages/capacityList/capacityListPage'
import { CAPACITY_ROUTES } from './paths'

export interface CapacityRoutesProps {
    history: History
    accountSlug: string
    setActiveSection: (section: string, header: string) => void
    replaceMessages: (id: string, status: MessageKind, text: string) => void
    hideMessage: (id: string) => void
    removeAllMessages: () => void
    source: '?from=flat' | '?from=nested'
}

export function CapacityRoutes(props: CapacityRoutesProps) {
    const { history, accountSlug, setActiveSection, replaceMessages, hideMessage, removeAllMessages } = props
    return (
        <Switch>
            <Route
                path={CAPACITY_ROUTES.list}
                render={() => (
                    <WithRoutePermission requiredPermissions={['partner_admin']}>
                        <FullWidthContainerBody>
                            <CapacityListPage
                                accountSlug={accountSlug}
                                setActiveSection={setActiveSection}
                                replaceMessages={replaceMessages}
                                hideMessage={hideMessage}
                            />
                        </FullWidthContainerBody>
                    </WithRoutePermission>
                )}
            />
            <Route
                path={CAPACITY_ROUTES.item}
                render={({ match }) => (
                    <WithRoutePermission requiredPermissions={['partner_admin']}>
                        <FullWidthContainerBody>
                            <CapacityPage
                                key={`${accountSlug}:${match.params.id}`}
                                history={history}
                                accountSlug={accountSlug}
                                setActiveSection={setActiveSection}
                                replaceMessages={replaceMessages}
                                hideMessage={hideMessage}
                            />
                        </FullWidthContainerBody>
                    </WithRoutePermission>
                )}
            />
            <Route
                path={CAPACITY_ROUTES.exception}
                render={() => (
                    <WithRoutePermission requiredPermissions={['partner_admin']}>
                        <FullWidthContainerBody>
                            <InventoryRuleForm
                                history={history}
                                accountSlug={accountSlug}
                                setActiveSection={setActiveSection}
                                replaceMessages={replaceMessages}
                                removeAllMessages={removeAllMessages}
                            />
                        </FullWidthContainerBody>
                    </WithRoutePermission>
                )}
            />
        </Switch>
    )
}
